import type { IInitPlayerPageShowPlayingParams } from './interfaces'

import { api } from '@setplex/tria-api'
import { createEvent } from 'effector'

export const initPlayerPageShowPlaying =
  createEvent<IInitPlayerPageShowPlayingParams>()

export const $tvShowCurrentEpisode = api.tvshows.$seriesPlaylist.map(
  (playlist) => playlist?.currentEpisode ?? null
)
